/**
 * @generated SignedSource<<349464af508c30a67db1fb2d6595391a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubProfileModelDiscountCategoryChoices = "DISCOUNT_PUPIL_OTHER" | "DISCOUNT_PUPIL_PPKID" | "FULL_PRICE" | "%future added value";
export type PianofunclubProfileModelStatusChoices = "ACTIVE" | "ARCHIVED" | "%future added value";
export type LoadAccountQuery$variables = {
  block?: number | null | undefined;
  profileId: string;
  startingYear?: number | null | undefined;
};
export type LoadAccountQuery$data = {
  readonly profile: {
    readonly accountNumber: string | null | undefined;
    readonly addressFirstLine: string | null | undefined;
    readonly addressSecondLine: string | null | undefined;
    readonly children: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly user: {
            readonly firstName: string;
            readonly id: string;
            readonly lastName: string;
          };
        } | null | undefined;
      } | null | undefined>;
    };
    readonly city: string | null | undefined;
    readonly dbsExpirationDate: string | null | undefined;
    readonly dbsNumber: string | null | undefined;
    readonly discountCategory: PianofunclubProfileModelDiscountCategoryChoices | null | undefined;
    readonly discountPercentage: number | null | undefined;
    readonly hasBook: boolean | null | undefined;
    readonly hasInstrument: boolean | null | undefined;
    readonly hasInvalidPhoneNumber: boolean;
    readonly hasReturnedInstrument: boolean | null | undefined;
    readonly id: string;
    readonly instrumentSuppliedByUs: boolean | null | undefined;
    readonly instruments: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly paidBySchool: boolean | null | undefined;
    readonly parentEnrolments: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly enroledTimestamp: string | null | undefined;
          readonly id: string;
          readonly pupilFirstName: string | null | undefined;
          readonly pupilLastName: string | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    };
    readonly phoneNumber: string | null | undefined;
    readonly postcode: string | null | undefined;
    readonly primaryParent: {
      readonly id: string;
      readonly phoneNumber: string | null | undefined;
      readonly user: {
        readonly email: string;
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string;
      };
    } | null | undefined;
    readonly pupilEnrolments: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly enroledTimestamp: string | null | undefined;
          readonly id: string;
        } | null | undefined;
      } | null | undefined>;
    };
    readonly school: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly schoolClass: string | null | undefined;
    readonly schoolYear: number | null | undefined;
    readonly schools: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    } | null | undefined> | null | undefined;
    readonly staffNoteForTeacher: string | null | undefined;
    readonly status: PianofunclubProfileModelStatusChoices;
    readonly teacherNoteForStaff: string | null | undefined;
    readonly teachers: ReadonlyArray<{
      readonly profileFirstName: string | null | undefined;
      readonly profileId: string | null | undefined;
      readonly profileLastName: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly teachingDays: ReadonlyArray<number | null | undefined> | null | undefined;
    readonly user: {
      readonly dateJoined: string;
      readonly email: string;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    };
  } | null | undefined;
};
export type LoadAccountQuery = {
  response: LoadAccountQuery$data;
  variables: LoadAccountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "block"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "profileId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startingYear"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enroledTimestamp",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "profileId"
      }
    ],
    "concreteType": "ProfileNode",
    "kind": "LinkedField",
    "name": "profile",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasInvalidPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schoolYear",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schoolClass",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "instruments",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "addressFirstLine",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "addressSecondLine",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "postcode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dbsNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dbsExpirationDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountCategory",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paidBySchool",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountPercentage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasBook",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasInstrument",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "instrumentSuppliedByUs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasReturnedInstrument",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "staffNoteForTeacher",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teacherNoteForStaff",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "block",
            "variableName": "block"
          },
          {
            "kind": "Variable",
            "name": "startingYear",
            "variableName": "startingYear"
          }
        ],
        "kind": "ScalarField",
        "name": "teachingDays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SchoolNode",
        "kind": "LinkedField",
        "name": "school",
        "plural": false,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SchoolNode",
        "kind": "LinkedField",
        "name": "schools",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DjangoUserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateJoined",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileNode",
        "kind": "LinkedField",
        "name": "primaryParent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DjangoUserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileNodeConnection",
        "kind": "LinkedField",
        "name": "children",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DjangoUserNode",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomProfileNode",
        "kind": "LinkedField",
        "name": "teachers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileLastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentNodeConnection",
        "kind": "LinkedField",
        "name": "parentEnrolments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrolmentNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EnrolmentNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pupilFirstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pupilLastName",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentNodeConnection",
        "kind": "LinkedField",
        "name": "pupilEnrolments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrolmentNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EnrolmentNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LoadAccountQuery",
    "selections": (v10/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "LoadAccountQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "57d61776f320bf71280f3b33235cb65e",
    "id": null,
    "metadata": {},
    "name": "LoadAccountQuery",
    "operationKind": "query",
    "text": "query LoadAccountQuery(\n  $profileId: ID!\n  $startingYear: Int\n  $block: Int\n) {\n  profile(id: $profileId) {\n    id\n    accountNumber\n    status\n    phoneNumber\n    hasInvalidPhoneNumber\n    schoolYear\n    schoolClass\n    instruments\n    addressFirstLine\n    addressSecondLine\n    city\n    postcode\n    dbsNumber\n    dbsExpirationDate\n    discountCategory\n    paidBySchool\n    discountPercentage\n    hasBook\n    hasInstrument\n    instrumentSuppliedByUs\n    hasReturnedInstrument\n    staffNoteForTeacher\n    teacherNoteForStaff\n    teachingDays(startingYear: $startingYear, block: $block)\n    school {\n      id\n      name\n    }\n    schools {\n      id\n      name\n    }\n    user {\n      id\n      email\n      firstName\n      lastName\n      dateJoined\n    }\n    primaryParent {\n      id\n      phoneNumber\n      user {\n        id\n        email\n        firstName\n        lastName\n      }\n    }\n    children {\n      edges {\n        node {\n          id\n          user {\n            id\n            firstName\n            lastName\n          }\n        }\n      }\n    }\n    teachers {\n      profileId\n      profileFirstName\n      profileLastName\n    }\n    parentEnrolments {\n      edges {\n        node {\n          id\n          pupilFirstName\n          pupilLastName\n          enroledTimestamp\n        }\n      }\n    }\n    pupilEnrolments {\n      edges {\n        node {\n          id\n          enroledTimestamp\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "70cdf169bd3c0cc5de3b8db348d5e873";

export default node;
